module.exports = __webpack_public_path__ + "img/Banner mediano 1.7e95fed4.png";